module.exports = __webpack_public_path__ + "static/img/switcher.35e60b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/review/switcher.png
// module id = A7tJ
// module chunks = 1